import { Row } from "antd";
import styled from "styled-components";

export const VoyageTableContainer = styled(Row)`
  .content {
    border-radius: 12px;
    background: var(--color-Base-Color-White, #fff);
    box-shadow: 0px 4px 6px 0px rgba(113, 130, 183, 0.25);
    padding: 16px;
  }
  .select {
    .ant-select-selector {
      border-radius: 12px;
      border-color: rgb(219, 226, 230) !important;
    }
    .ant-select-arrow {
      margin-top: -6px !important;
    }
    &:hover {
      .ant-select-selector {
        border-color: rgb(219, 226, 230) !important;
      }
    }
  }
  .ant-select-focused {
    .ant-select-selector {
      border-color: rgb(219, 226, 230) !important;
    }
  }
`;
